export const STRATEGY_POPULATE_FULL = [
    "localizations",
    "images",
    "banner",
    "pricingModels",
    "owner",
    "assets",
    "exchanges",
    "logo",
];
export const STRATEGY_POPULATE_DEFAULT = [
    "localizations",
    "images",
    "banner",
    "pricingModels",
    "owner",
    "assets",
];
export const STRATEGY_POPULATE_LIST = [
    "logo",
    "exchanges",
    "pricingModels",
];
export const STRATEGY_POPULATE_MINIMAL = ["logo", "exchanges"];
export const STRATEGY_POPULATE_PUBLIC = [
    "logo",
    "images",
    "banner",
    "exchanges",
    "localizations",
];
export const STRATEGY_POPULATE = {
    FULL: STRATEGY_POPULATE_FULL,
    DEFAULT: STRATEGY_POPULATE_DEFAULT,
    LIST: STRATEGY_POPULATE_LIST,
    MINIMAL: STRATEGY_POPULATE_MINIMAL,
    PUBLIC: STRATEGY_POPULATE_PUBLIC,
};
